import { render, staticRenderFns } from "./collect-add-or-update.vue?vue&type=template&id=8645a694&scoped=true&"
import script from "./collect-add-or-update.vue?vue&type=script&lang=js&"
export * from "./collect-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./collect-add-or-update.vue?vue&type=style&index=0&id=8645a694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8645a694",
  null
  
)

export default component.exports